import { Grid, Typography } from '@mui/material';
import React from 'react';
import TestPlansSection from '../../components/project-dashboard/test-plans/TestPlansSection';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';

const TestIntelligencePage = () => {
  return (
    <DashboardLayout>
      <Grid container spacing={2} className="mt-4">
        <Grid item xs={12}>
          <Typography variant="h4" className="mb-4">
            Test Intelligence
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TestPlansSection />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default TestIntelligencePage;
